import { ArrowRight, TrendingUp } from "lucide-react";

function Row({ label, before, after, invertGood = false }) {
  if (before == null || after == null || before === after) return null;
  const improved = invertGood ? after < before : after > before;
  return (
    <div className="flex items-center justify-between gap-3 text-sm" data-testid="before-after-row">
      <span className="text-slate-400">{label}</span>
      <span className="flex items-center gap-2 font-mono">
        <span className="text-slate-500">{before}</span>
        <ArrowRight className="h-3.5 w-3.5 text-slate-600" />
        <span className={improved ? "text-emerald-400 font-semibold" : "text-slate-300"}>{after}</span>
      </span>
    </div>
  );
}

export function BeforeAfter({ delta }) {
  if (!delta) return null;
  const ib = delta.independence_before, ia = delta.independence_after;
  const diff = (ia ?? 0) - (ib ?? 0);
  const hasScoreChange = ib != null && ia != null && ib !== ia;

  return (
    <div className="text-center" data-testid="before-after">
      <p className="mono-label text-emerald-400">Tu empresa depende menos de ti</p>
      {hasScoreChange ? (
        <>
          <div className="mt-4 flex items-center justify-center gap-4">
            <span className="font-head text-4xl sm:text-5xl font-extrabold text-slate-500">{ib}</span>
            <ArrowRight className="h-6 w-6 text-slate-600" />
            <span className="font-head text-4xl sm:text-5xl font-extrabold text-emerald-400">{ia}</span>
          </div>
          {diff > 0 && (
            <p className="mt-2 inline-flex items-center gap-1.5 text-emerald-400 font-semibold"><TrendingUp className="h-4 w-4" /> +{diff} puntos de Independence Score</p>
          )}
        </>
      ) : (
        <p className="mt-3 text-sm text-slate-300">Prueba verificada correctamente. El sistema ya reduce esta dependencia.</p>
      )}
      <div className="mt-5 space-y-2.5 text-left max-w-sm mx-auto">
        <Row label="Dependencia del propietario" before={delta.owner_before} after={delta.owner_after} invertGood />
        <Row label="Intervenciones del propietario" before={delta.interventions_before} after={delta.interventions_after} invertGood />
      </div>
      <p className="mt-4 text-xs text-slate-500">Esta mejora refleja los cambios verificados en la dependencia de tu empresa.</p>
    </div>
  );
}
